import { useState } from 'react';
import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useAdvanceOnboarding, useOnboarding } from '@/lib/queries';
import { Button } from './ui/button';
export function Onboarding() {
  const { t } = useTranslation();
  const query = useOnboarding();
  const mutation = useAdvanceOnboarding();
  const [title, setTitle] = useState('');
  const [error, setError] = useState(false);
  const step = query.data?.step;
  if (step === undefined || step >= 3) return null;
  const advance = async (skip = false, create = false) => {
    setError(false);
    try {
      await mutation.mutateAsync({
        step,
        skip,
        ...(create && title.trim() ? { title: title.trim() } : {}),
      });
      setTitle('');
    } catch {
      setError(true);
    }
  };
  return (
    <section
      aria-label={t('onboarding.title')}
      className="mb-5 flex flex-col gap-3 rounded-card border border-line bg-accent-soft p-5"
    >
      <p className="text-xs text-muted">{t('onboarding.step', { step: step + 1 })}</p>
      <h2 className="font-serif text-xl">{t(`onboarding.steps.${step}`)}</h2>
      <p className="text-sm text-ink-2">{t(`onboarding.hints.${step}`)}</p>
      {step < 2 && (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            void advance(false, true);
          }}
          className="flex flex-wrap gap-2"
        >
          <label className="flex min-w-0 flex-1 flex-col gap-1 text-sm">
            {t(step === 0 ? 'onboarding.task' : 'onboarding.goal')}
            <input
              maxLength={200}
              disabled={mutation.isPending}
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="min-h-11 rounded-lg border border-line bg-surface px-3 text-base"
            />
          </label>
          <Button type="submit" disabled={mutation.isPending || !title.trim()} className="self-end">
            {t('onboarding.add')}
          </Button>
        </form>
      )}
      {step === 2 && (
        <div className="flex flex-wrap gap-3">
          {[
            ['/week', 'nav.week'],
            ['/goals', 'nav.goals'],
            ['/search', 'search.title'],
          ].map(([path, label]) => (
            <Link
              key={path}
              to={path!}
              className="inline-flex min-h-11 min-w-11 items-center text-sm text-accent"
            >
              {t(label!)}
            </Link>
          ))}
        </div>
      )}
      {error && (
        <p role="alert" className="text-sm">
          {t('onboarding.error')}
        </p>
      )}
      <div className="flex flex-wrap gap-2">
        <Button disabled={mutation.isPending} onClick={() => void advance()}>
          {t(step === 2 ? 'onboarding.finish' : 'onboarding.next')}
        </Button>
        <Button variant="ghost" disabled={mutation.isPending} onClick={() => void advance(true)}>
          {t('onboarding.skip')}
        </Button>
      </div>
    </section>
  );
}
